const writing = new Audio("/assets/audio/writing.mp3");
export function playScribble() {
    if (writing.readyState === HTMLMediaElement.HAVE_ENOUGH_DATA) {
        writing.play();
    }
}
